<template>
  <!-- 20220527 Created by LYJ COMMON POPUP COMPONENT USING <DXPOPUP> -->
  <DxPopup
    :width="device === 'mobile' ? '90vw' : width"
    :height="device === 'mobile' ? '80vh' : height"
    :visible="popupVisible"
    :show-title="useTitle"
    :close-on-outside-click="closeOnOutsideClick"
    :drag-enabled="enableDrag"
    :show-close-button="false"
    container=".dx-viewport"
    :title="title"
    :min-width="minWidth"
    :max-width="maxWidth"
    :min-height="minHeight"
    :max-height="maxHeight"
    @showing="onShowing"
    @hidden="handlePopupHidden"
  >
    <DxToolbarItem widget="dxButton" toolbar="top" location="after" :options="closeButtonOptions" />
    <template #content>
      <div style="display: flex; flex-direction: column; height: 100%;">
        <div style="flex: 1 1 auto; min-height:0;">
          <DxScrollView width="100%" height="100%" class="iPopup">
            <!-- <img src="images/Popup-Scrolling-Image.jpg" /> -->
            <div id="textBlock"><slot name="content"></slot></div>
            <div id="gridBolck"><slot name="grid"></slot></div>
            <div id="imageBlock"><slot name="image"></slot></div>
          </DxScrollView>
        </div>
        <div style="flex-shrink: 0; padding: 10px;">
          <slot name="footer"></slot>
        </div>
      </div>
    </template>
  </DxPopup>
</template>
<script>
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup'
import { DxScrollView } from 'devextreme-vue/scroll-view'
import { mapState } from 'vuex'

export default {
  name: 'i-dxpopup',
  components: {
    DxPopup,
    DxScrollView,
    DxToolbarItem
  },
  props: {
    popupVisible: {
      type: Boolean,
      default: () => false
    },
    width: {
      type: String,
      default: () => '550'
    },
    minWidth: {
      type: String,
      default: () => '450'
    },
    maxWidth: {
      type: String,
      default: () => '1540'
    },
    height: {
      type: String,
      default: () => '350'
    },
    minHeight: {
      type: String,
      default: null
    },
    maxHeight: {
      type: String,
      default: null
    },
    useTitle: {
      type: Boolean,
      default: () => true
    },
    isCloseOnOutsideClick: {
      type: Boolean,
      default: () => true
    },
    title: { type: String, default: () => 'title...' },
    enableDrag: { type: Boolean, default: () => true },
    vHtmlContent: {
      type: String,
      default: () => 'input popup content'
    }
  },
  data() {
    return {
      closeButtonOptions: {
        icon: 'close',
        onClick: () => {
          this.$emit('popupCloseButtonClick')
        }
      }
    }
  },
  computed: {
    ...mapState({ device: state => state.app.device })
  },
  mounted() {},
  methods: {
    closeOnOutsideClick(e) {
      // console.log(e.target.className)
      if (
        e.target.className == 'dx-overlay-wrapper dx-popup-wrapper dx-overlay-shader' ||
        e.target.className == 'dx-icon dx-icon-close' ||
        e.target.className == 'dx-closebutton'
        // || e.target.className == 'dx-button-content'
      )
        if (this.isCloseOnOutsideClick) {
          this.$emit('popupCloseButtonClick', e)
        }
    },
    onShowing(e) {
      this.$emit('showing', e)
    },
    handlePopupHidden() {
      this.$emit('popupCloseButtonClick')
    }
  }
}
</script>
<style lang="scss" scoped>
#textBlock {
  // padding-left: 20px;
  // padding-right: 20px;
  line-height: 1.6em;
}

#gridBolck {
  line-height: 2em;
  font-weight: bold;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 20px;
  width: 300px;
}
</style>
